import { Validators } from '@angular/forms';
import {CustomValidator, fmcValidator} from '../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';
import { defaultFieldConfig } from '../../../../firstmac-material-lib/projects/fmc-elements/src/lib/common';

export class PersonalDetailsModel {
  personList = {
    value: [],
    validation: Validators.compose([]),
  };
  faDataCheck = {
    value: null,
    validation: Validators.compose([]),
  };
}

export class IndividualPersonModel {
  partyId = {
    value: null,
    validation: Validators.compose([])
  };
  partyRoleId = {
    value: null,
    validation: Validators.compose([])
  };
  firstName = {
    value: null,
    validationAsync: [fmcValidator('nameRequired')],
    disabled: false
  };
  middleName = {
    value: null,
    validationAsync: [fmcValidator('name')]
  };
  lastName = {
    value: null,
    validationAsync: [fmcValidator('nameRequired')],
    disabled: false
  };
  dateOfBirth = {
    value: null,
    validationAsync: [fmcValidator('isAdult')],
  };
  driversLicence = {
    value: null,
    validation: Validators.compose([
      CustomValidator.driversLicenceValidator(defaultFieldConfig.driversLicenceNumber, [], 'licenceStateCode')
    ])
  };
  driversLicenceState = {
    value: null,
    validation: Validators.compose([])
  };
  licenceStateCode = {
    value: null,
    validation: Validators.compose([])
  };
  driversLicenceCardNumber = {
    value: null,
    validation: Validators.compose([
      CustomValidator.driversLicenceValidator(defaultFieldConfig.driversLicenceCardNumber, [], 'licenceStateCode')
    ])
  };
  email = {
    value: null,
    validationAsync: [fmcValidator('emailRequired')]
  };

  // residentialAddress = new AddressModel();
  // postalAddress = new AddressModel();
  homeAddress = {
    value: {},
    validation: Validators.compose([])
  };

  dependentsOver11 = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.max(100),
      Validators.min(0)
    ])
  };

  dependentsUnder11 = {
    value: 0,
    validation: Validators.compose([
      Validators.required,
      Validators.max(100),
      Validators.min(0)
    ])
  };

  optOutElectronicIdentityAcceptance = {
    value: true,
    validation: Validators.compose([])
  };

  optOutElectronicDeliveryAcceptance = {
    value: false,
    validation: Validators.compose([])
  };

  orgABN = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };

  orgName = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };

  orgTrading = {
    value: null,
    validation: Validators.compose([
      // Validators.required
    ])
  };

  // Used to show/hide organisation details Person's card
  showPersonABN = {
    value: false,
    validation: Validators.compose([])
  };

  showPreviousAddress = {
    value: false,
    validation: Validators.compose([])
  };

  residencyType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };

  // length of stay
  stayAtHomeYears = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0),
      Validators.pattern('[0-9]*')
    ])
  };

  stayAtHomeMonths = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.min(0),
      Validators.max(11),
      Validators.pattern('[0-9]*')
    ])
  };

  // same as flags
  residentialAddressSameAsBorrower1 = {
    value: false,
    validation: Validators.compose([])
  };
  previousAddressSameAsBorrower1 = {
    value: false,
    validation: Validators.compose([])
  };
  postalAddressAsHome = {
    value: true,
    validation: Validators.compose([])
  };
  postalAddress = {
    value: null,
    validation: Validators.compose([])
  };
  postSettlementAddressAsHome = {
    value: true,
    validation: Validators.compose([])
  };
  postSettlementAddress = {
    value: null,
    validation: Validators.compose([])
  };
  postSettlementAddressNotAvailable = {
    value: false,
    validation: Validators.compose([])
  };
  // abn ext
  ext = {
    value: null,
    validation: Validators.compose([])
  };

  maritalStatus = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };

  auCitizen = {
    value: false,
    validation: Validators.compose([
      Validators.required
    ])
  };

  relationships = {
    value: [],
    validation: Validators.compose([])
  };

  ownProperty = {
    value: false,
    validation: Validators.compose([
      Validators.required
    ])
  };

  // home
  nccpCovered = {
    value: false,
    validation: Validators.compose([
      Validators.required
    ])
  };

  // home
  nccpNotes = {
    value: null,
    validation: Validators.compose([
      Validators.maxLength(1000)
    ])
  };

  borrowerGuarantor = {
    value: 'borrower',
    validation: Validators.compose([
      Validators.required
    ])
  };

  privacyConsent = {
    value: true,
    validation: Validators.compose([])
  };

  creditReportEnquiryId = {
    value: null,
    validation: Validators.compose([])
  };

  previousAddressList = {
    value: [],
    validation: Validators.compose([]),
  };

  // phones
  phones = {
    value: [],
    validation: Validators.compose([])
  };
}

export class IndividualNonApplicantModel {
  partyRoleId = {
    value: null,
    validation: Validators.compose([])
  };
  firstName = {
    value: null,
    validationAsync: [fmcValidator('nameRequired')]
  };
  middleName = {
    value: null,
    validationAsync: [fmcValidator('name')]
  };
  lastName = {
    value: null,
    validationAsync: [fmcValidator('nameRequired')]
  };
  email = {
    value: null,
    validationAsync: [fmcValidator('emailRequired')]
  };
  nonApplicant = {
    value: true,
    validation: Validators.compose([])
  };
  // phones
  phones = {
    value: [],
    validation: Validators.compose([])
  }
  
  relationships = {
    value: [],
    validation: Validators.compose([])
  }
}

export class PreviousAddressModel {
  prevResidencyType = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ])
  };

  previousAddressSameAsBorrower1 = {
    value: null,
    validation: Validators.compose([])
  };

  stayAtPrevYears = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.pattern('[0-9]*')
    ])
  };

  stayAtPrevMonths = {
    value: null,
    validation: Validators.compose([
      Validators.required,
      Validators.max(11),
      Validators.pattern('[0-9]*')
    ])
  };

  previousAddress = {
    value: null,
    validation: Validators.compose([])
  };
}


export class IndividualRelationshipModel {
  from = {
    value: null,
    validation: Validators.compose([]),
  };

  to = {
    value: null,
    validation: Validators.compose([]),
  };

  type = {
    value: null,
    validation: Validators.compose([
      Validators.required
    ]),
  };
}

export class IndividualPhoneModel {
  phoneType = {
    value: 'mobile',
    validation: Validators.compose([
      Validators.required
    ]),
  };
  phoneNumber = {
    value: null,
    validationAsync: [fmcValidator('phoneNumberRequired')]
  };
}

export class IndividualNasPhoneModel {
  phoneType = {
    value: 'mobile',
    validation: Validators.compose([]),
  };
  phoneNumber = {
    value: null,
    validationAsync: [fmcValidator('phoneNumberRequired')]
  };
}
